import { showNotification } from "@mantine/notifications";
import { MedplumClient } from "@medplum/core";

export async function availityBotHandler(medplum: MedplumClient, payload: any) {
    try{
        const response = await medplum.executeBot(
          {
            system: "https://api-stage.healthconnect.systems/bots",
            value: "availity-service",
          },
          payload
        );
        return response

    }catch(error){
        console.log(error);
        showNotification({
          color: "red",
          message: error as any,
        });

    }
} 
 export function restructureArray(arr:any) {
  return arr.map((item:any) => ({
    label: item.value,
    value: `${item.code}-${item.value}`,
  }));
}
